export const MODULES = {
  CORPORATE_CARDS: "CorporateCards",
  CREDIT_CARDS: "CreditCards",
  PRIVATE_VEHICLES: "PrivateVehicles",
};
